import { Room, TwilioError } from "twilio-video";
import { useEffect } from "react";
import { Callback } from "../../../types";

export const useHandleRoomDisconnection = (
	room: Room | null,
	onError: Callback,
): void => {
	useEffect(() => {
		if (room) {
			const onDisconnected = (_: Room, error: TwilioError) => {
				if (error?.code === 53118) {
					console.info("[VideoProvider:useHandleRoomDisconnection] The event has been ended by the host");
				} else if (error) {
					console.error(`[VideoProvider:useHandleRoomDisconnection] ${error.message} `, JSON.stringify(error));
					onError(error);
				}
				else {
					console.info("[VideoProvider:useHandleRoomDisconnection] You have been disconnected");
				}
			};

			room.on("disconnected", onDisconnected);
			return () => {
				room.off("disconnected", onDisconnected);
			};
		}
	}, [
		room,
		onError
	]);
}
